export default __webpack_public_path__ + "static/media/wheel_left_wh.e0cb33ae.svg";